import { getAuth, signOut } from "firebase/auth";

async function signOutUser() {
  const auth = getAuth();

  try {
    await signOut(auth);
    // Sign-out successful.
    console.log("User signed out successfully.");
    // Optionally, redirect the user to the login page or update the UI
  } catch (error) {
    // An error happened.
    console.error("Error signing out:", error);
  }
}

export default signOutUser;
